import * as TYPES from './types';

const initialState = {
  activeButtonIds: [],
};

const viewer = (state = initialState, action) => {
  const mergeState = data => ({ ...state, ...data });
  switch (action.type) {
    case TYPES.SET_ACTIVE_BUTTON_IDS:
      return mergeState({ activeButtonIds: action.payload });
    default:
      return state;
  }
};

export default viewer;
